import { render, staticRenderFns } from "./TwoModules.vue?vue&type=template&id=0c18d10c&"
import script from "./TwoModules.vue?vue&type=script&lang=js&"
export * from "./TwoModules.vue?vue&type=script&lang=js&"
import style0 from "./TwoModules.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports